//
//
//
//
//
//
//

import LineageTableau from '@/modules/tasks/tableau/components/LineageTableau';
export default {
  name: 'DatasourceTabLineage',
  components: {
    LineageTableau: LineageTableau
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      data_lineage: {}
    };
  },
  created: function created() {
    var tables = this.item.tables.map(function (element) {
      return element;
    });
    this.data_lineage = {
      tables: tables,
      datasource: {
        object_name: this.item.object_name,
        focus: true
      },
      views: []
    };
  }
};